// internal
import { axios, def, array, handleError, handleResponse, likedPosts } from './internal';
import { LikeList } from './like-list';

function Feed(cursor, batch, limit, vecMode, country, gender, setData) {
    setData((prev) => ({ ...prev, loading: true }));

    axios
        .get('/api/feed', {
            params: {
                cursor: cursor ? JSON.stringify(cursor) : undefined,
                batch,
                limit,
                vecMode: vecMode === 'both' ? undefined : vecMode,
                country: country || undefined,
                gender: gender || undefined,
            },
        })
        .then(async (res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    const { cursor, posts: fetched } = res.data.data;
                    // the server does not send the viewer's liked state; it comes from this device's liked posts,
                    // loaded from the server once when the device has none yet
                    await LikeList();
                    const liked = likedPosts();
                    const posts = fetched.map((p) => ({ ...p, post: { ...p.post, liked: p.post._id in liked } }));
                    setData((prev) => ({
                        cursor: cursor,
                        batch: batch,
                        loadmore: cursor !== null,
                        posts: array.concatArray(prev.posts, posts),
                    }));
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        })
        .finally(() => {
            setData((prev) => ({ ...prev, loading: false }));
        });
}

export { Feed };
